// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__5QYaD","image":"Logo_image__sxEx_","hidden":"Logo_hidden__WCFJt"};